import React, { memo, useEffect } from 'react';
import { ThemeIcon } from './ThemeSwitcherIcon';
import { storageGet, storageSet } from '../../../../helpers';
import { getStorageKey, THEMES } from '../../../../config';
import { Control } from '../RightControl';
const doc = document.documentElement;
const defaultStorageKey = getStorageKey('THEME');
export const HeaderTheme = memo(({ onChange, onAfterChange, lightThemeName = THEMES.light, disableStorageSave = false, storageKey = defaultStorageKey }) => {
    const onClick = (ev) => {
        if (onChange) {
            onChange(ev);
            return;
        }
        let theme = '';
        if (doc.hasAttribute(lightThemeName)) {
            doc.removeAttribute(lightThemeName);
            theme = 'dark';
        }
        else {
            doc.setAttribute(lightThemeName, 'true');
            theme = 'light';
        }
        !disableStorageSave && storageSet(storageKey, theme);
        onAfterChange && onAfterChange(theme);
    };
    useEffect(() => {
        if (disableStorageSave) {
            return;
        }
        const value = storageGet(storageKey, '');
        value === 'light' && doc.setAttribute(lightThemeName, 'true');
        onAfterChange && onAfterChange(value || 'dark');
    }, [disableStorageSave, storageKey, lightThemeName, onAfterChange]);
    return (React.createElement(Control, { onClick: onClick },
        React.createElement(ThemeIcon, null)));
});
